import React, { FC, PropsWithChildren } from "react";
import styled from "styled-components";

export const DialogActions: FC<PropsWithChildren> = ({ children }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  border-top: 1px solid #e0e0e0;
  padding: 1em 1em;
  display: flex;
  gap: 0.5em;
  align-items: center;
  justify-content: flex-end;

  > .loader-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  p {
    flex: 1;
  }

  button {
    font-size: 1em;
    border-radius: 0.5em;
  }
`;
